import { ActionIcons, useInputIcons } from "PFComponents/action_icons";
import { Label } from "PFComponents/label";
import { FilterWithDefaults, Id } from "PFTypes";

import css from "./filter_header.module.scss";

type FilterHeaderProps = {
  filter: FilterWithDefaults;
  onChange: (id: Id | Id[] | null) => void;
  canRestore: boolean;
  canClear: boolean;
  disabled?: boolean;
};

export const FilterHeader = ({ filter, onChange, canRestore, canClear, disabled }: FilterHeaderProps) => {
  const actionIcons = useInputIcons({
    onRestore: canRestore
      ? () => onChange((filter.defaultValue ?? filter.default_value) as Id | Id[] | null)
      : undefined,
    onClear: canClear ? () => onChange([]) : undefined,
    disabled,
    label: filter.title
  });

  return (
    <div className={css.header}>
      <Label text={filter.title} required={filter.required} />
      <ActionIcons actionIcons={actionIcons} />
    </div>
  );
};
